/* WLB Reichweiten-Simulator — pure vanilla JS, no React/Babel/Tailwind. */
(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────
  // Calc model — "physics-lite" Energie-Modell (Einheiten in Kommentaren:
  // kg, m/s, N, Wh/km, W). Intern konsistent: Roll- + Luft- + Steigungs- +
  // Anfahr-Energie am Rad, minus Tret-Leistung des Fahrers, geteilt durch
  // Antriebs-/Motor-Wirkungsgrad → Batterie-Wh/km. KEINE gestapelten Willkür-
  // Faktoren. Bewusst eine SCHÄTZUNG — es gibt kein echtes Höhenprofil, keine
  // echte Zuladung, keinen echten Reifendruck, keinen Akku-Gesundheitswert und
  // keine bike-spezifische Motor-Effizienzkarte.
  // ─────────────────────────────────────────────────────────
  var G = 9.81;                     // m/s²

  // Das vorhandene "Gewicht"-Feld = Fahrergewicht (kg). Dazu Rad-Masse +
  // kleine Pauschale (Schloss, Kleidung, Wasser …).
  var BIKE_WEIGHT_KG = { city: 24, trekking: 26, emtb: 25, cargo: 35 };  // kg
  var FIXED_GEAR_KG = 2;            // kg

  // Rollwiderstands-Beiwert — HIER gehört der Reifentyp hin, nicht als globaler Faktor.
  var TIRE_CRR = { schmal: 0.0048, standard: 0.0065, grob: 0.0100 };

  // Aerodynamik CdA je Radtyp (m²). Sitzposition wirkt nur auf die Fläche.
  var BIKE_CDA = { city: 0.68, trekking: 0.60, emtb: 0.66, cargo: 0.80 };  // m²
  var POSITION_CDA_FACTOR = { aufrecht: 1.05, sportlich: 0.88 };

  // Ungefähre Steigungsdichte (Höhenmeter pro km) statt Willkür-Aufschlag.
  var ASCENT_M_PER_KM = { flach: 2, huegelig: 12, bergig: 30 };  // m/km

  // Kleine Anfahr-/Stopp-Mechanik-Pauschale je Nutzungstyp (Wh/km am Rad).
  var STOP_START_WHEEL_WHKM = { city: 0.60, trekking: 0.25, emtb: 0.40, cargo: 0.75 };

  // Direkter Gegen-/Rückenwind-Proxy (m/s) — bewusst moderat, damit Wind den
  // Verbrauch nicht überproportional hochtreibt (früher ±3 → fast doppelter
  // Luftwiderstand bei Gegenwind).
  var WIND_MPS = { rueckenwind: -2, windstill: 0, gegenwind: 2 };  // m/s

  // Dämpfung des Tempo-/Wind-Effekts im Luftwiderstand: der reine v²-Term über-
  // bewertet die Geschwindigkeit für einen Alltags-Rechner (Bosch zeigt z. B. nur
  // ~7 % mehr Reichweite von 25→18 km/h). Wir stauchen die Abweichung von einer
  // Referenzgeschwindigkeit — als folge die Unterstützung dem Reisetempo. Betrifft
  // auch den Wind (läuft über dieselbe Luftgeschwindigkeit) → doppelt gebremst.
  var AERO_REF_MPS = 5.6;       // m/s (~20 km/h) Referenz
  var AERO_SPEED_DAMP = 0.60;   // 1 = volle Physik, kleiner = flacher

  // Antriebs-Wirkungsgrad (nur Getriebeverluste).
  var GEAR_EFF = { keine: 0.97, nabe7: 0.92, ketten10: 0.96, ketten12: 0.95, pinion: 0.92, automatik: 0.91 };

  // Motor-/Controller-Wirkungsgrad — die Drehmoment-Klasse ist KEIN direkter
  // Wh/km-Multiplikator, die Unterschiede bleiben klein.
  var MOTOR_EFF = { sparsam: 0.80, mittel: 0.79, stark: 0.78, kraftvoll: 0.78 };

  // Anteil des Rad-Energiebedarfs, den der MOTOR übernimmt (der Rest kommt vom
  // Fahrer). Höherer Modus = mehr Motoranteil. WICHTIG: so skaliert der Verbrauch
  // LINEAR mit dem physikalischen Bedarf. (Das frühere „Motor füllt nur die Lücke
  // zwischen Bedarf und Fahrer"-Modell ließ bei langsamem Tempo die Reichweite
  // explodieren, weil der Fahrer den kleinen Bedarf fast allein deckte.)
  var MODE_MOTOR_SHARE = {
    'eco-plus': 0.40, eco: 0.49, tour: 0.57, 'tour-plus': 0.64,
    sport: 0.74, emtb: 0.72, turbo: 0.89, auto: 0.62
  };

  // Konstante elektrische Grundlast als Leistung (W), nicht als Fake-Wh/km.
  var AUXILIARY_POWER_W = 7;        // W

  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  function tempCapFactor(t) {
    t = Number(t);
    // Nur Akku-Kapazitätseffekt. Luftdichte wird separat berechnet.
    if (t <= -10) return 0.65;
    if (t < 0) return 0.65 + (t + 10) * 0.02;   // -10 °C = 0.65, 0 °C = 0.85
    if (t < 15) return 0.85 + t * 0.01;         // 15 °C = 1.00
    if (t <= 25) return 1.00;
    if (t <= 35) return 1.00 - (t - 25) * 0.002;
    return 0.95;
  }

  function compute(s) {
    var speedKmh = clamp(Number(s.speed) || 22, 10, 30);   // km/h
    var speedMps = speedKmh / 3.6;                          // m/s

    var bikeMass = BIKE_WEIGHT_KG[s.biketype] || BIKE_WEIGHT_KG.trekking;              // kg
    var totalMassKg = Math.max(45, Number(s.weight) || 75) + bikeMass + FIXED_GEAR_KG; // kg (Fahrer+Rad+Pauschale)

    var crr = TIRE_CRR[s.tires] || TIRE_CRR.standard;
    var cda = (BIKE_CDA[s.biketype] || BIKE_CDA.trekking) * (POSITION_CDA_FACTOR[s.position] || 1);  // m²

    var windMps = WIND_MPS[s.wind] || 0;                                  // m/s
    // Relative Luftgeschwindigkeit für die Aero-Verluste (Gegenwind erhöht sie).
    var airSpeedMps = Math.max(1.5, speedMps + windMps);                  // m/s
    // Gedämpfte Luftgeschwindigkeit: Abweichung von der Referenz gestaucht, damit
    // Tempo UND Wind den Verbrauch nur moderat statt voll-quadratisch beeinflussen.
    var aeroMps = Math.max(1.5, AERO_REF_MPS + (airSpeedMps - AERO_REF_MPS) * AERO_SPEED_DAMP);  // m/s

    // Luftdichte aus Temperatur bei Normaldruck; geklammert (Höhe/Druck kein Input).
    var rho = clamp(1.225 * 293.15 / (273.15 + Number(s.temp)), 1.15, 1.35);  // kg/m³

    // Rollwiderstand: F = m·g·Crr (N) → Energie/km in Wh = N / 3.6.
    var rollingWhKm = (totalMassKg * G * crr) / 3.6;                      // Wh/km

    // Luftwiderstand: F = 0.5·rho·CdA·v_air² (N) → Wh/km = N / 3.6. v_air ist die
    // gedämpfte Luftgeschwindigkeit (siehe AERO_SPEED_DAMP), nicht das rohe Tempo.
    var aeroForceN = 0.5 * rho * cda * aeroMps * aeroMps;                 // N
    var aeroWhKm = aeroForceN / 3.6;                                      // Wh/km

    // Steigungsenergie: E = m·g·Höhenmeter / 3600 (Wh/km).
    var ascentMPerKm = ASCENT_M_PER_KM[s.terrain] || ASCENT_M_PER_KM.flach;
    var climbWhKm = (totalMassKg * G * ascentMPerKm) / 3600;             // Wh/km

    var stopStartWhKm = STOP_START_WHEEL_WHKM[s.biketype] || 0.25;        // Wh/km

    var wheelWhKm = rollingWhKm + aeroWhKm + climbWhKm + stopStartWhKm;   // Wh/km am Rad (Bedarf)

    // Der MOTOR übernimmt einen modus-abhängigen ANTEIL des Rad-Bedarfs (den Rest
    // tritt der Fahrer). Anteil-Modell statt „Lücke füllen": der Verbrauch skaliert
    // damit linear mit dem Bedarf — langsames Tempo lässt die Reichweite nicht mehr
    // explodieren. Trittfrequenz moduliert den Anteil nur leicht (runder treten =
    // etwas weniger Motoranteil).
    var gearEff = GEAR_EFF[s.gears] || GEAR_EFF.ketten10;
    var cadenceAdj = clamp(1 - (Number(s.cadence) - 75) * 0.003, 0.9, 1.1);
    var motorShare = clamp((MODE_MOTOR_SHARE[s.mode] || MODE_MOTOR_SHARE.tour) * cadenceAdj, 0.15, 0.98);
    var motorWheelWhKm = wheelWhKm * motorShare;                         // Wh/km (am Rad, vom Motor)

    // Rad-Energie → Batterie-Energie über Motor/Controller + Antrieb.
    var motorEff = MOTOR_EFF[s.motor] || MOTOR_EFF.mittel;
    var motorBatteryWhKm = motorWheelWhKm / Math.max(0.55, gearEff * motorEff);  // Wh/km

    // Elektrische Grundlast = Leistung / Tempo → langsam fahren ergibt natürlich
    // etwas mehr Aux-Wh/km, ganz ohne Fake-„Langsam-Strafe".
    var auxiliaryWhKm = AUXILIARY_POWER_W / speedKmh;                    // Wh/km

    var whkm = Math.max(1.0, motorBatteryWhKm + auxiliaryWhKm);         // Wh/km (Batterie)

    // Voller Nennakku, kleine BMS-/Reserve-Marge.
    var usableWh = (Number(s.akku) || 625) * tempCapFactor(s.temp) * 0.95;  // Wh
    var km = usableWh / whkm;                                            // km

    return {
      km: Math.round(km),
      lo: Math.round(km * 0.88),
      hi: Math.round(km * 1.10),
      whkm: Math.round(whkm * 10) / 10,
      usableWh: Math.round(usableWh)
    };
  }
  function interpretation(r) {
    var km = r.km;
    if (km < 30) return 'Gut für kurze Stadtfahrten und Erledigungen in der Nachbarschaft.';
    if (km < 55) return 'Reicht komfortabel für den täglichen Pendelweg (ca. 2× 12 km) inkl. Reserve.';
    if (km < 85) return 'Zur Arbeit und zurück (2× 20 km) — und am Wochenende bleibt noch Saft für eine Runde.';
    if (km < 130) return 'Tagestouren ins Umland sind problemlos drin — auch mit Café-Stopp und Umweg.';
    return 'Reicht für lange Wochenend-Touren und Bikepacking-Etappen am Stück.';
  }
  function recommend(s, r) {
    var tiers = [360, 400, 500, 540, 600, 625, 720, 750, 800];
    if (r.km < 35) {
      var i = tiers.indexOf(s.akku);
      var bigger = tiers[Math.min(tiers.length - 1, i + 1)];
      if (bigger > s.akku) {
        return 'Eher knapp: bei diesem Setup könnte ein größerer Akku sinnvoll sein — z. B. ' + bigger + ' Wh statt ' + s.akku + ' Wh. Richtwert, keine Garantie.';
      }
      return 'Eher knapp: du liegst nahe an der Grenze deines Akkus — ein Modus tiefer würde Reserve schaffen. Richtwert, keine Garantie.';
    }
    if (r.km < 70) return 'Dein ' + s.akku + ' Wh-Akku dürfte für dieses Setup gut reichen, mit etwas Reserve. Nur ein Richtwert — die echte Reichweite hängt von Fahrweise, Wetter, Gelände, Zuladung und Akku-Alter ab.';
    return 'Dein ' + s.akku + ' Wh-Akku sollte für dieses Setup reichlich Reserve bieten. Nur ein Richtwert — die echte Reichweite hängt von Fahrweise, Wetter, Gelände, Zuladung und Akku-Alter ab.';
  }

  // ─────────────────────────────────────────────────────────
  // State + initial values
  // ─────────────────────────────────────────────────────────
  var state = {
    akku: 625, terrain: 'flach', mode: 'tour',
    biketype: 'trekking', tires: 'standard', position: 'aufrecht', motor: 'mittel',
    weight: 80, speed: 22, cadence: 70,
    wind: 'windstill', temp: 20, gears: 'ketten10'
  };

  // ─────────────────────────────────────────────────────────
  // DOM helpers
  // ─────────────────────────────────────────────────────────
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'style') n.setAttribute('style', attrs[k]);
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    if (kids != null) {
      if (!Array.isArray(kids)) kids = [kids];
      kids.forEach(function (c) {
        if (c == null || c === false) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }

  // Segmented button group
  function seg(label, key, options) {
    var wrap = el('div', { class: 'wlb-sim-field' }, [
      el('div', { class: 'wlb-sim-label' }, label)
    ]);
    var group = el('div', { class: 'wlb-sim-seg' });
    options.forEach(function (opt) {
      var b = el('button', {
        type: 'button',
        class: 'wlb-sim-seg-btn' + (state[key] === opt.value ? ' is-active' : ''),
        'data-value': opt.value,
        'aria-pressed': state[key] === opt.value ? 'true' : 'false',
        onclick: function () {
          state[key] = opt.value;
          Array.prototype.slice.call(group.children).forEach(function (c) {
            var match = c.getAttribute('data-value') == opt.value;
            c.classList.toggle('is-active', match);
            c.setAttribute('aria-pressed', match ? 'true' : 'false');
          });
          render();
        }
      }, opt.label);
      group.appendChild(b);
    });
    wrap.appendChild(group);
    return wrap;
  }

  // Slider with live label
  function slider(label, key, min, max, step, unit) {
    var labelNode = el('span', { class: 'wlb-sim-slider-val' }, state[key] + (unit || ''));
    var input = el('input', {
      type: 'range', min: min, max: max, step: step || 1,
      value: state[key], class: 'wlb-sim-slider'
    });
    input.addEventListener('input', function () {
      state[key] = Number(input.value);
      labelNode.textContent = state[key] + (unit || '');
      render();
    });
    return el('div', { class: 'wlb-sim-field' }, [
      el('div', { class: 'wlb-sim-label-row' }, [
        el('div', { class: 'wlb-sim-label' }, label),
        labelNode
      ]),
      input
    ]);
  }

  // Select dropdown
  function select(label, key, options) {
    var sel = el('select', { class: 'wlb-sim-select' });
    options.forEach(function (opt) {
      var o = el('option', { value: opt.value }, opt.label);
      if (state[key] === opt.value) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { state[key] = sel.value; render(); });
    return el('div', { class: 'wlb-sim-field' }, [
      el('div', { class: 'wlb-sim-label' }, label),
      sel
    ]);
  }

  // ─────────────────────────────────────────────────────────
  // Result + bike recommendation render
  // ─────────────────────────────────────────────────────────
  function bikeCard(b) {
    var price = b.priceFrom ? b.priceFrom.toLocaleString('de-DE') + ' €' : '';
    var card = el('a', {
      class: 'wlb-sim-bike',
      href: b.shopUrl || '#',
      target: '_blank',
      rel: 'noopener'
    }, [
      (function () {
        var img = el('img', { alt: (b.brand || '') + ' ' + (b.name || ''), loading: 'lazy', class: 'wlb-sim-bike-img' });
        var handle = b.id || (window.WLBImg ? window.WLBImg.handleFromUrl(b.shopUrl) : '');
        if (window.WLBImg) { window.WLBImg.set(img, handle, b.imageUrl); }
        else if (b.imageUrl) { img.src = b.imageUrl; }
        return el('div', { class: 'wlb-sim-bike-img-wrap' }, [img]);
      })(),
      el('div', { class: 'wlb-sim-bike-body' }, [
        el('div', { class: 'wlb-sim-bike-brand' }, b.brand || ''),
        el('div', { class: 'wlb-sim-bike-name' }, b.name || ''),
        el('div', { class: 'wlb-sim-bike-meta' }, [
          el('span', null, b.type || ''),
          el('span', null, '·'),
          el('span', null, (b.akku || 0) + ' Wh')
        ]),
        el('div', { class: 'wlb-sim-bike-bottom' }, [
          el('div', { class: 'wlb-sim-bike-price' }, price ? 'ab ' + price : ''),
          el('span', { class: 'wlb-sim-bike-link' }, 'Mehr →')
        ])
      ])
    ]);
    return card;
  }
  function pickBikes(state, requiredKm) {
    var list = (window.WLB_BIKES || []).slice();
    list = list.filter(function (b) {
      var fits = !b.fitFor || b.fitFor.indexOf(state.terrain) >= 0;
      var bigEnough = (b.akku || 0) >= state.akku * 0.6;
      return fits || bigEnough;
    });
    list.sort(function (a, b) { return Math.abs((a.akku || 0) - state.akku) - Math.abs((b.akku || 0) - state.akku); });
    return list.slice(0, 3);
  }

  // ─────────────────────────────────────────────────────────
  // Layout — built once, mutated on each render() call
  // ─────────────────────────────────────────────────────────
  var inputsCol, resultsCol, sceneHost, scene, bikesRow, root;

  function buildShell() {
    var inputs = el('div', { class: 'wlb-sim-inputs' }, [
      seg('Akku', 'akku', [
        { value: 360, label: '360' }, { value: 400, label: '400' },
        { value: 500, label: '500' }, { value: 540, label: '540' },
        { value: 600, label: '600' }, { value: 625, label: '625' },
        { value: 720, label: '720' }, { value: 750, label: '750' },
        { value: 800, label: '800' }
      ]),
      seg('Gelände', 'terrain', [
        { value: 'flach', label: 'Flach' },
        { value: 'huegelig', label: 'Hügelig' },
        { value: 'bergig', label: 'Bergig' }
      ]),
      seg('Modus', 'mode', [
        { value: 'eco-plus', label: 'Eco+' }, { value: 'eco', label: 'Eco' },
        { value: 'tour', label: 'Tour' }, { value: 'tour-plus', label: 'Tour+' },
        { value: 'sport', label: 'Sport' }, { value: 'emtb', label: 'eMTB' },
        { value: 'turbo', label: 'Turbo' }, { value: 'auto', label: 'Auto' }
      ]),
      seg('Fahrradtyp', 'biketype', [
        { value: 'city', label: 'City' },
        { value: 'trekking', label: 'Trekking' },
        { value: 'emtb', label: 'E-MTB' },
        { value: 'cargo', label: 'Cargo' }
      ]),
      seg('Reifen', 'tires', [
        { value: 'schmal', label: 'Schmal' },
        { value: 'standard', label: 'Standard' },
        { value: 'grob', label: 'Grob/Stollen' }
      ]),
      seg('Sitzposition', 'position', [
        { value: 'aufrecht', label: 'Aufrecht' },
        { value: 'sportlich', label: 'Sportlich' }
      ]),
      seg('Motor · Drehmoment', 'motor', [
        { value: 'sparsam', label: '≤ 50 Nm' },
        { value: 'mittel', label: '65 Nm' },
        { value: 'stark', label: '85 Nm' },
        { value: 'kraftvoll', label: '95+ Nm' }
      ]),
      slider('Gewicht', 'weight', 50, 150, 1, ' kg'),
      slider('Geschwindigkeit', 'speed', 15, 25, 1, ' km/h'),
      slider('Trittfrequenz', 'cadence', 40, 110, 1, ' rpm'),
      seg('Wind', 'wind', [
        { value: 'rueckenwind', label: 'Rücken' },
        { value: 'windstill', label: 'Windstill' },
        { value: 'gegenwind', label: 'Gegen' }
      ]),
      slider('Temperatur', 'temp', -10, 35, 1, ' °C'),
      select('Schaltung', 'gears', [
        { value: 'keine', label: 'Singlespeed' },
        { value: 'nabe7', label: 'Naben­schaltung 7-Gang' },
        { value: 'ketten10', label: 'Ketten­schaltung 10/11-Gang' },
        { value: 'ketten12', label: 'Ketten­schaltung 12-Gang' },
        { value: 'pinion', label: 'Pinion / Rohloff' },
        { value: 'automatik', label: 'Automatik (Vanmoof, Enviolo)' }
      ])
    ]);
    inputsCol = inputs;

    resultsCol = el('div', { class: 'wlb-sim-results' });
    sceneHost = el('div', { class: 'wlb-sim-scene-host' });
    bikesRow = el('div', { class: 'wlb-sim-bikes-grid' });

    var grid = el('div', { class: 'wlb-sim-grid' }, [
      inputs,
      el('div', { class: 'wlb-sim-rightcol' }, [
        sceneHost,
        resultsCol,
        el('div', { class: 'wlb-sim-bikes-section' }, [
          el('div', { class: 'wlb-sim-section-kicker' }, 'E-Bike-Vorschläge für dein Setup'),
          bikesRow
        ])
      ])
    ]);

    root.appendChild(grid);
  }

  function render() {
    var r = compute(state);
    var interp = interpretation(r);
    var rec = recommend(state, r);

    // Animated bike scene — created once, updated on each render
    if (window.WlbSimulatorScene) {
      if (!scene) scene = window.WlbSimulatorScene.create(sceneHost, state, r);
      else scene.update(state, r);
    }

    resultsCol.innerHTML = '';
    resultsCol.appendChild(el('div', { class: 'wlb-sim-result-card' }, [
      el('div', { class: 'wlb-sim-result-kicker' }, 'Reichweite'),
      el('div', { class: 'wlb-sim-km' }, r.km + ' km'),
      el('div', { class: 'wlb-sim-km-range' }, r.lo + '–' + r.hi + ' km realistisch'),
      el('div', { class: 'wlb-sim-stats' }, [
        el('div', { class: 'wlb-sim-stat' }, [
          el('span', { class: 'wlb-sim-stat-label' }, 'Verbrauch'),
          el('span', { class: 'wlb-sim-stat-value' }, r.whkm + ' Wh/km')
        ]),
        el('div', { class: 'wlb-sim-stat' }, [
          el('span', { class: 'wlb-sim-stat-label' }, 'Nutzbar'),
          el('span', { class: 'wlb-sim-stat-value' }, r.usableWh + ' Wh')
        ])
      ])
    ]));
    resultsCol.appendChild(el('div', { class: 'wlb-sim-interp' }, interp));
    resultsCol.appendChild(el('div', { class: 'wlb-sim-rec' }, rec));

    bikesRow.innerHTML = '';
    pickBikes(state, r.km).forEach(function (b) { bikesRow.appendChild(bikeCard(b)); });
  }

  function init() {
    root = document.getElementById('wlb-simulator-root');
    if (!root) return;
    if (!window.WLB_BIKES) {
      root.innerHTML = '<div class="wlb-sim-error">Bike-Katalog konnte nicht geladen werden.</div>';
      return;
    }
    root.innerHTML = '';
    buildShell();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
